import routes from 'js/core_pre_webpack/routes';
import * as ApiUtils from 'js/utils/api_utils';
import toSnakecaseKeys from 'js/utils/toSnakecaseKeys';
import { NewsType } from 'js/social/shared/types';

type ViewedComment = {
  userId: number;
  commentableId: number | string;
  commentableType: NewsType;
  commentId: number | string;
};

export function createCommentView(
  props: ViewedComment,
): Promise<{ success: boolean }> {
  // Spammers get rate-limited "spoofed" comments with ID 0
  if (props.commentId) {
    return ApiUtils.post(
      routes.api_v0_community_comment_views_path({ subdomain_param: 'api' }),
      toSnakecaseKeys(props),
    );
  }
  return new Promise((resolve) => resolve({ success: true }));
}
